import axios, { AxiosError, AxiosRequestHeaders } from 'axios';
import { rest } from '../constants/rest';
import { IRestParams, TRestResponse } from '../types/rest';

class Rest {
    // Storage-name ключа токена
    static REST_TOKEN_STORAGE = 'token';

    x = (): TRestResponse => ({
        isError: true,
        err: 1,
    });

    fetch = async ({
        data, headers: fetchHeaders, method, objectName,
    }: IRestParams): Promise<TRestResponse> => {
        try {
            const headers: AxiosRequestHeaders = {
                'Content-Type': 'application/json',
                ...fetchHeaders,
            };
            const token = Rest.getToken();

            if (typeof token === 'string') {
                headers.Authorization = `Token ${token}`;
            }

            const response = await axios(`${rest.url}${objectName}`, {
                method,
                data,
                headers,
            });
            return {
                isError: false,
                response,
            };
        } catch (err) {
            if (err instanceof AxiosError) {
                return {
                    isError: true,
                    response: err.response,
                };
            }
            return {
                isError: true,
                err,
            };
        }
    };

    /**
     * Получить токен авторизации
     */
    public static getToken = () => localStorage.getItem(Rest.REST_TOKEN_STORAGE) || '';

    /**
     * Удалить токен авторизации
     */
    public static removeToken = () => localStorage.removeItem(Rest.REST_TOKEN_STORAGE);

    /**
     * Сохранить токен авторизации
     * @param token - токен авторизации
     */
    public static saveToken = (token: string) => localStorage.setItem(Rest.REST_TOKEN_STORAGE, token);
}

export default Rest;
